import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ContextualField, Group } from '../../../models/index';
import * as Fields from '../../../common/helpers/contextual';
import { SpotManualInputsWidget } from '../spotManualInputs.widget';
import { spotWidgetsContextualFields } from '../../../common/helpers/contextual';

class SpotManualInputsContextualController implements angular.IComponentController {
    commonProperties: ContextualField[];
    errors: ContextualField[];
    properties: ContextualField[];

    readonly currentGroup: Group;
    readonly manualSpotGroups: Group[];
    readonly selectedItem: SpotManualInputsWidget;

    static $inject = [];

    $onInit() {
        const properties = angular.copy(spotWidgetsContextualFields);
        _.find(properties, f => f.propertyName === 'groupProperty').extraData.groups = this.getSelectableGroups();

        this.commonProperties = Fields.WidgetFields.map(w => w);
        this.properties = properties;
    }

    private getSelectableGroups(): { guid: string; uniqueName: string }[] {
        return [{ guid: null, uniqueName: 'Current group' }, ...this.manualSpotGroups];
    }
}

export const wtSpotManualInputsContextual: ComponentDefinition = {
    componentId: 'wtSpotManualInputsContextual',
    controller: SpotManualInputsContextualController,
    template: require('./spotManualInputsContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        currentGroup: '<?',
        formController: '=?',
        manualSpotGroups: '<',
        selectedItem: '<',
    }
};